import { createI18n } from 'vue-i18n'
import es from '../locales/es.json'
import en from '../locales/en.json'

// Detectar idioma del navegador
function getDefaultLocale() {
  const savedLocale = localStorage.getItem('locale')
  // Si el idioma guardado es catalán, cambiar a español
  if (savedLocale === 'ca') {
    localStorage.setItem('locale', 'es')
    return 'es'
  }
  if (savedLocale && savedLocale !== 'ca') {
    return savedLocale
  }
  
  const browserLocale = navigator.language || navigator.userLanguage
  const supportedLocales = ['es', 'en']
  
  // Mapear códigos de idioma del navegador a nuestros códigos
  const localeMap = {
    'es': 'es',
    'es-ES': 'es',
    'en': 'en',
    'en-US': 'en',
    'en-GB': 'en'
  }
  
  const mappedLocale = localeMap[browserLocale] || localeMap[browserLocale.split('-')[0]]
  
  return supportedLocales.includes(mappedLocale) ? mappedLocale : 'es'
}

const i18n = createI18n({
  legacy: false, // Usar Composition API
  locale: getDefaultLocale(),
  fallbackLocale: 'es',
  messages: {
    es,
    en
  }
})

export default i18n 